module.exports = "/assets/3e126c729fc848f6b87aae2a096a2215.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/QM.png
// module id = 1756
// module chunks = 0